import { render } from "./ArticleTextAndImage.vue?vue&type=template&id=9d1ff438"
import script from "./ArticleTextAndImage.vue?vue&type=script&lang=js"
export * from "./ArticleTextAndImage.vue?vue&type=script&lang=js"

import "./ArticleTextAndImage.vue?vue&type=style&index=0&id=9d1ff438&lang=scss"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__